// 액션 타입 정의
const CLIENT_RESET = 'CLIENT_RESET';
const USER_COMPANY = 'USER_COMPANY';
const USER_NAME = 'USER_NAME';
const USER_EMAIL = 'USER_EMAIL';
const USER_GRADE = 'USER_GRADE';

// 액션 생섬함수 정의
export const clientReset = () => ({ type: CLIENT_RESET });
export const editUserCompany = value => ({ type: USER_COMPANY, value });
export const editUserName = value => ({ type: USER_NAME, value });
export const editUserEmail = value => ({ type: USER_EMAIL, value });
export const editUserGrade = value => ({ type: USER_GRADE, value });

// 초기상태 정의
const initialState = {
  userCompany: '',
  userName: '',
  userEmail: '',
  userGrade: '' // plus freeTrial basic
};
// 리듀서 작성
export default function clientReducer(state = initialState, action) {
  switch (action.type) {
    case CLIENT_RESET:
      return initialState;
    case USER_COMPANY:
      return {
        ...state,
        userCompany: action.value
      };
    case USER_NAME:
      return {
        ...state,
        userName: action.value
      };
    case USER_EMAIL:
      return {
        ...state,
        userEmail: action.value
      };
    case USER_GRADE:
      return {
        ...state,
        userGrade: action.value
      };
    default:
      return state;
  }
}
